import * as Yup from 'yup';
import * as moment from 'moment';
import { stateConvert } from 'utils/stateAbbreviation';
import { getCanadaStates, getCurrencyCodeByCountry, getLoggedInUserCountry, getStateAbbr } from 'helpers';

export function setInitialValues(draftData) {
    let rateFromDate = new Date();
    let rateToDate = new Date();
    rateToDate.setDate(rateToDate.getDate() + 30);
    const userCountry = getLoggedInUserCountry();
    const currencyCode = getCurrencyCodeByCountry(getLoggedInUserCountry());


    let setState = draftData?.locationAddress?.stateFullName

    return {
        //basic info
        userName: draftData?.customerName ? draftData?.customerName : '',
        phoneNumber: draftData?.contactNumber ? draftData?.contactNumber : '',
        businessName: draftData?.locationName ? draftData?.locationName : '',
        email: draftData?.emailAddress ? draftData?.emailAddress : '',
        address: draftData?.locationAddress?.street ? draftData?.locationAddress?.street : '',
        city: draftData?.locationAddress?.city ? draftData?.locationAddress?.city : '',
        state: draftData?.locationAddress?.state ? getStateAbbr(draftData?.locationAddress?.state, userCountry) : '',
        zip: draftData?.locationAddress?.zipCode ? draftData?.locationAddress?.zipCode : '',
        notes: draftData?.notes ? draftData?.notes : '',

        //bill To
        billToCheckBox: false,
        billToUserName: draftData?.billingAddress?.name ? draftData?.billingAddress?.name : '',
        billToEmail: draftData?.billToEmailAddress ? draftData?.billToEmailAddress : '',
        billToPhoneNumber: draftData?.billingAddress?.contactNumber ? draftData?.billingAddress?.contactNumber : '',
        billToBusinessName: draftData?.billingAddress?.locationName ? draftData?.billingAddress?.locationName : '',
        billToAddress: draftData?.billingAddress?.street ? draftData?.billingAddress?.street : '',
        billToCity: draftData?.billingAddress?.city ? draftData?.billingAddress?.city : '',
        billToState: draftData?.billingAddress?.state ? getStateAbbr(draftData?.billingAddress?.state, userCountry) : '',
        billToZip: draftData?.billingAddress?.zipCode ? draftData?.billingAddress?.zipCode : '',
        taxId: draftData?.businessInfo?.taxId ? draftData?.businessInfo?.taxId : '',
        businessURL: draftData?.businessInfo?.businessUrl ? draftData?.businessInfo?.businessUrl : '',
        businessDescription: draftData?.businessInfo?.businessDescription ? draftData?.businessInfo?.businessDescription : '',
        otherContactEmail: draftData?.otherContactEmail ? draftData?.otherContactEmail : '',

        //fee structure
        feeTypeRadio: draftData?.feeStructure?.feeType ? draftData?.feeStructure?.feeType : 'PERCENTAGE',
        percentageValue: draftData?.feeStructure?.feeTypePercentage?.fee ? draftData?.feeStructure?.feeTypePercentage?.fee : '',
        costPerPalletValue: draftData?.feeStructure?.feeTypeCostPallet?.fee ? draftData?.feeStructure?.feeTypeCostPallet?.fee : '',
        percentageCurrencyLists: draftData?.feeStructure?.feeTypePercentage?.currency ? draftData?.feeStructure?.feeTypePercentage?.currency : currencyCode,
        costPerPalletCurrencyLists: draftData?.feeStructure?.feeTypeCostPallet?.currency ? draftData?.feeStructure?.feeTypeCostPallet?.currency : currencyCode,
        selectLocation: draftData?.locationName ? draftData?.locationName : '', // as of now location name in basic info is set here as well
        selectPalletType: draftData?.feeStructure?.flatFee?.selectedPaalletType ? draftData?.feeStructure?.flatFee?.selectedPaalletType : 'gradeA',

        //flat fee
        addLocationInput: '',
        flatFeeValue: '',
        flatFeeCurrencyLists: currencyCode,
        rateStartDate: rateFromDate.toISOString().substring(0, 10),
        rateExpDate: rateToDate.toISOString().substring(0, 10),

        material: "WOOD",
        condition0: "",
        condition1: "",
        condition2: "",
        condition3: "",
        palletType: "",
        moisture: "",
        size: "",
        grade: "",


        //payment method
        paymentModeRadio: draftData?.paymentInfo?.paymentMode ? draftData?.paymentInfo?.paymentMode : 'PT',
        invoicePaymentModeRadio: 'ach',
        invoiceSchedulePeriod: draftData?.paymentInfo?.invoiceScheduled ? draftData?.paymentInfo?.invoiceScheduled : 'WEEKLY',

        stateTaxExemption: draftData?.locationAddress?.stateFullName
            || getCanadaStates.find((item) => item.isoCode === `${draftData?.locationAddress?.state}`.trim().toUpperCase())?.name
            //   || abbreviationToState(draftData?.locationAddress?.state)
            || draftData?.locationAddress?.state
            || "",
        //location setup
        addLocationName: '',
        addLocationAddress: '',
        addLocationCity: '',
        addLocationState: '',
        addLocationZip: '',
        addLocationContactNumber: '',
        addUserName: '',
        addUserEmail: '',
        addUserPhoneNumber: '',

    };
}

const VALIDATION_SCHEMA = () => {
    let schemaAttributes = {
        //basic info
        userName: Yup.string().trim().required('Name is required.'),
        phoneNumber: Yup.string().required('Phone number is required.').matches(/^(?!(?:\D*0)+\D*$)\(?([0-9]{3})\)?[-. ]?[0-9]{3}[-. ]?[0-9]{4}$/, 'Phone number is not valid'),
        businessName: Yup.string().required('Company Name is required.'),
        email: Yup.string().email('Please enter a valid email.').required('Email is required.'),
        // .matches(/^[a-zA-Z0-9_!#$%&amp;'*+/=?`{|}~^.-]+@[a-zA-Z0-9-]+(.com|.net|.co.in|.org|.int.edu|.gov|mil|.int|.edu|.cc|.co.uk|us){1}$/,"Please enter a valid email."),
        address: Yup.string().required('Address is required.'),
        city: Yup.string().required('City is required.'),
        state: Yup.string().required('State is required.'),
        zip: Yup.string().required('Zip is required.').min(5, "5 digits required.").max(5, "Zip code should be of 5 digits only."),
        notes: Yup.string().max(200, "Only 200 characters allowed."),

        //bill to
        billToUserName: Yup.string().trim().required('Bill To Name is required.'),
        billToEmail: Yup.string().email('Please enter a valid email.').required('Email is required.'),
        billToPhoneNumber: Yup.string().required('Bill To Phone number is required.').matches(/^(?!(?:\D*0)+\D*$)\(?([0-9]{3})\)?[-. ]?[0-9]{3}[-. ]?[0-9]{4}$/, 'Phone number is not valid'),
        billToBusinessName: Yup.string().required('Bill To Company Name is required.'),
        billToAddress: Yup.string().required('Bill To Address is required.'),
        billToCity: Yup.string().required('Bill To City is required.'),
        billToState: Yup.string().required('Bill To State is required.'),
        billToZip: Yup.string().required('Bill To Zip is required.').min(5, "5 digits required.").max(5, "Zip code should be of 5 digits only."),
        otherContactEmail: Yup.string().email('Please enter a valid email.'),

        //business info
        taxId: Yup.string().min(9, "9 digits required.").max(9, "Tax ID should be of 9 digits only."),
        businessURL: Yup.string().max(200, "Only 200 characters allowed."),
        businessDescription: Yup.string().max(200, "Only 200 characters allowed."),

        //location setup
        addLocationName: Yup.string().trim(),
        addLocationAddress: Yup.string(),
        addLocationCity: Yup.string(),
        addLocationState: Yup.string(),
        addLocationZip: Yup.string().min(5, "5 digits required.").max(5, "Zip code should be of 5 digits only."),
        addUserName: Yup.string().trim(),
        addUserPhoneNumber: Yup.string().matches(/^(?!(?:\D*0)+\D*$)\(?([0-9]{3})\)?[-. ]?[0-9]{3}[-. ]?[0-9]{4}$/, 'Phone number is not valid'),
        addUserEmail: Yup.string().email('Please enter a valid email.'),
    }

    return Yup.object().shape(schemaAttributes);
}

export { VALIDATION_SCHEMA };
